import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-toggle-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="form-check form-switch d-flex justify-content-start align-items-center  h-100">
      <input 
        class="form-check-input border-2 constomised " 
        type="checkbox" 
        role="switch" 
        [checked]="isChecked"
        (change)="onToggleChange($event)">
    </div>
  `,
  styleUrls: ['./toggle-reusable.component.scss']

})
export class ToggleRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  public isChecked: boolean = false;
  public toggleField: string | null = null;

 agInit(params: ICellRendererParams): void {
    this.params = params;
    const data = params?.data || {};
    
    const possibleFields = ['isEnabled', 'deleted', 'is_active'];
    for (const field of possibleFields) {
      if (field in data) {
        this.toggleField = field;
        this.isChecked = !!data[field];  
        break;
      }
    }
  }


 refresh(params: ICellRendererParams): boolean {
    this.params = params;
    const data = params?.data || {};
    
    if (this.toggleField && this.toggleField in data) {
      this.isChecked = !!data[this.toggleField];
    }

    return true;
  }


 onToggleChange(event: any): void {
    const checked = event.target.checked;

    if (this.toggleField) {
      this.params.data[this.toggleField] = checked;
    }

    if (this.params.context?.componentParent?.onStatusToggle) {
      this.params.context.componentParent.onStatusToggle(
        this.params.data,
        checked,
        this.toggleField
      );
    }
  }


}
